import { jsx as _jsx } from "react/jsx-runtime";
import FlipClock, { FlipClockFace } from '../flip-clock/FlipClock';
const Countdown = props => {
    const { theme, size, endDateTime } = props;
    return (_jsx(FlipClock, { dateTime: endDateTime, countdown: true, clockFace: FlipClockFace.DAILY_COUNTER, theme: theme, size: size }));
};
export default Countdown;
